module.exports = __webpack_public_path__ + "static/P1-Hobart-VIP-Office-5a2b0ff9ab7b8e3ca6d4901672f04f76.jpeg";